<form [formGroup]="formGroup()" class="d-flex flex-column my-2">
	<mat-form-field appearance="fill">
		<input matInput (dateChange)="setDate($event)" formControlName="date" [matDatepicker]="datePicker" />
		<mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
		<mat-datepicker #datePicker></mat-datepicker>
	</mat-form-field>
	<mat-form-field appearance="fill">
		<input
			matInput
			appDetectValueChangeOnFocusOut
			(valueChangeOnFocusOut)="setTime($event)"
			formControlName="time"
			type="time"
		/>
		<button mat-icon-button matSuffix (click)="timePicker.open()">
			<i class="far fa-clock" style="font-size: 18px"></i>
		</button>
	</mat-form-field>
	<ngx-mat-timepicker (timeSet)="setTime($event)" [minutesGap]="5" [format]="24" #timePicker></ngx-mat-timepicker>
</form>
